import { ViewNotFound } from '@view/view_not_found/view_not_found_route.component';
import { FixedRoutes } from './fixed_routes.component';
import { Heading } from './heading.component';
import { LegacyShell3Layout } from './legacy_shell-3_layout.component';
import { ListRoot } from './list_root.component';
import { Root } from './root.component';
import { SelectedAppointmentCase } from './selected_appointment_case.component';
import { SelectedMessagingCase } from './selected_messagingCase.component';

interface Props {}

export function ViewPatientCases(_: Props) {
	return (
		<ViewPatientCases.Root>
			<LegacyShell3Layout />
		</ViewPatientCases.Root>
	);
}

// This is mostly done to make it easier to compose in Patient Old.
// If all was in React we would not need to do this.
ViewPatientCases.Root = Root;
ViewPatientCases.FixedRoutes = FixedRoutes;
ViewPatientCases.Heading = Heading;
ViewPatientCases.ListRoot = ListRoot;
ViewPatientCases.AppointmentCase = SelectedAppointmentCase;
ViewPatientCases.MessagingCase = SelectedMessagingCase;
ViewPatientCases.ViewNotFound = ViewNotFound;
